import axios from 'axios';
import { API_BASE_URL } from '../config/api';

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // Request timeout
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
    'Access-Control-Allow-Origin': '*'
  },
  withCredentials: false
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add it to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Ensure proper URL construction by removing any double slashes
    const url = config.url.replace(/\/+/g, '/');
    config.url = url.startsWith('/') ? url.substring(1) : url;
    console.log('Making request to:', config.baseURL + '/' + config.url);
    // console.log('Request config:', config);
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Response received:', response.config.url);
    return response;
  },
  (error) => {
    console.error('Response error:', error.config?.url, error.message);
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('tokenPayload');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 